export default {
	formatEmptyFilter: (val, sign = '--') => {
		switch (val) {
			case '': 
			case '()':
			case '(IPv4 CIDR)':
			case '(IPv6 CIDR)': 
			case '/': 
				return sign
			break;
			default:
				return val
			break;
		}
	},
	formatWithParentheses: (val) => {
		if(!val) {
			return val
		}
		let regWithParentheses = /\(+|\)+/;
		if(regWithParentheses.test(val)) {
			return val
		} else {
			return `(${val})`
		}
	}
};


// WEBPACK FOOTER //
// ./src/filters/index.js